<script lang="ts">
import Drawer from '@/components/drawer/Drawer.svelte'
import DrawerContent from '@/components/drawer/DrawerContent.svelte'
import DrawerHeader from '@/components/drawer/DrawerHeader.svelte'
import { testIds } from '@/constants'
import { closeDrawer } from '@/modules/drawers'
import { t } from '@/modules/translations'
import { matchUrl } from '@/utils/regExps'

const buildGdprText = () => {
	return $t('gdpr.dataPrivacyText')
		.replace(
			matchUrl,
			'<a href="//$1" target="_blank" class="color-slate-500 hover:color-slate-700 transition-colors underline">$1</a>',
		)
		.replaceAll('\n', '<br/>')
}
</script>

<Drawer onClose={closeDrawer} testId={testIds.gdprDrawer}>
	<DrawerHeader title={$t('options.gdpr')} />
	<DrawerContent>
		<div class="text-sm">
			{@html buildGdprText()}
		</div>
	</DrawerContent>
</Drawer>
